import { createContext, useContext, useRef } from 'react';

const FlowContext = createContext(null);

export const useFlow = () => useContext(FlowContext);

export const FlowProvider = ({ children }) => {
  const resolvers = useRef({});

  const registerResolver = (key, resolve) => {
    resolvers.current[key] = resolve;
  };

  const resolveStep = (key, data) => {
    if (resolvers.current[key]) {
      resolvers.current[key](data);
      delete resolvers.current[key];
    }
  };

  return (
    <FlowContext.Provider value={{ registerResolver, resolveStep }}>
      {children}
    </FlowContext.Provider>
  );
};
